import script from "./rizhipingdingdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./rizhipingdingdetail.vue?vue&type=script&setup=true&lang=js"

import "./rizhipingdingdetail.vue?vue&type=style&index=0&id=1bb053d0&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb053d0"]])

export default __exports__